(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-product-recommendations"]) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    // Hand-picked products are rendered server-side
    if (productRecommendationsSection.dataset.manual) { return; }
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", productRecommendationsSection.dataset.url);
    request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
        theme.ProductBlockManager.loadImages(productRecommendationsSection);
        theme.initAnimateOnScroll();
        }
    };
    request.send();
    };
    // fetch when section reloads in editor
    document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
        loadProductRecommendationsIntoSection();
    }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

    if (!window.__relatedProductFormAddToCartBound) {
      window.__relatedProductFormAddToCartBound = true;
      document.addEventListener('submit', function(evt) {
        var form = evt.target;
        if (!form || !form.classList || !form.classList.contains('related-product-form')) { return; }
        evt.preventDefault();

        var button = form.querySelector('button[type="submit"]');
        var previousHtml = button ? button.innerHTML : null;
        if (button) {
          button.setAttribute('disabled', 'disabled');
          button.innerHTML = '<div class="loading-spinner loading-spinner--in-btn"></div>';
        }

        var formData = new FormData(form);
        formData.append('sections', 'cart-drawer');

        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        }).then(function(res) {
          return res.json().then(function(data) {
            if (!res.ok) { throw data; }
            return data;
          });
        }).then(function() {
          document.documentElement.dispatchEvent(
            new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } })
          );
          document.dispatchEvent(
            new CustomEvent('theme:open-cart-drawer', { bubbles: true, cancelable: false })
          );
        }).catch(function(err) {
          var message = (err && err.description) || (err && err.message) || 'Unable to add to cart.';
          if (window.theme && typeof window.theme.showQuickPopup === 'function' && button) {
            window.theme.showQuickPopup(message, window.jQuery ? window.jQuery(button) : button);
          } else {
            window.alert(message);
          }
        }).finally(function() {
          if (button) {
            button.removeAttribute('disabled');
            if (previousHtml !== null) { button.innerHTML = previousHtml; }
          }
        });
      });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
